<template>
  <div class="icase clearfix">
    <div class="w">
      <div class="headx">
        <h2>
          <em>
            <b>师资</b>力量
          </em>
          <span></span>
        </h2>
        <a href="/team" class="mo">MORE+</a>
      </div>
      <div class="tod" id="icase">
        <ul class="list clearfix">
          <li v-for="(item, index) in nowTeachers" :key="index">
            <a :href="'/team_in?id=' + item.id" :title="item.title" class="img">
              <img :src="http + item.attachfile" :alt="item.title" :title="item.title" />
              <div class="cover"></div>
            </a>
            <div class="wd">
              <span>
                <a :href="'/team_in?id=' + item.id" :title="item.title">{{ item.title }}</a>
              </span>
              <div class="descrption"></div>
              <a :href="'/team_in?id=' + item.id" class="detail s"></a>
            </div>
            <div class="shadow"></div>
          </li>
        </ul>
      </div>
      <!-- <div class="arrow">
        <a href="javascript:;" class="arrow_r s"></a>
        <a href="javascript:;" class="arrow_l s"></a>
      </div> -->
    </div>
  </div>
</template>

<script>
import method from "@/utils/Untitl.js";
export default {
  data() {
    return {
      http: process.env.VUE_APP_BASE_API,
      nowTeachers: [],
    };
  },
  mounted() {
    this.getTeachers();
  },
  methods: {
    async getTeachers() {
      const res = await method.index();
      if (res.code == 1) {
        this.nowTeachers = res.data.teachers;
      }
      // console.log(this.nowTeachers);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/pc/index_Teachers.scss";
</style>
